exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ds-form-helper-text{color:var(--ds-color-london-20);font-family:var(--ds-type-system-sans-lining);font-size:var(--ds-type-scale-0);font-weight:400;line-height:var(--ds-type-leading-lower);max-width:33rem}.ds-form-helper-text--inverse{color:var(--ds-color-london-95)}", ""]);

// exports
exports.locals = {
	"ds-form-helper-text": "ds-form-helper-text",
	"ds-form-helper-text--inverse": "ds-form-helper-text--inverse"
};